<template>
    <article>
        <div style="max-width: 770px;">
            <div class="breadcrumbs p14 mb-5">
                <router-link to="/">Home</router-link> &raquo; <a href="#">Legal</a> &raquo; <a href="#">Partner List</a>
            </div>
            <h3 class="mb-5">Partner List</h3>
            <div class="light mb-5">
                <p>Broadsurf LLC's affiliated companies, its and its affiliated companies' service providers, and its and its affiliated companies' marketing partners</p>
                <p>Kona Messaging, LLC</p>
                <p>Loan 2 Funds California LLC</p>
                <p>If accepted for a loan, my personal loan lender</p>
                <p>If accepted for a loan, my personal loan lender's service providers and marketing partners</p>
                <p>If I choose, other non-lender providers in Broadsurf LLC's network, and their service providers and marketing partners</p>
            </div>
            <div class="p14 text-right"><router-link to="/">Return Home</router-link></div>
        </div>
    </article>
</template>

<script>
export default {
    name: "Partners",
    title: 'Partners',
}
</script>

<style>

</style>
